// extracted by mini-css-extract-plugin
export default {"container":"Toasts_container__FJfwE","header":"Toasts_header__TBLUz","title":"Toasts_title__lwTJi","icon":"Toasts_icon__gtHMW","message":"Toasts_message__HRg8h"};